import { privateClient } from "./client";
import { getChannel } from "../lib/utils";

function getCheckoutUrlV2(msisdn, checkoutObj) {
  const url = `/customers/${msisdn}/smartcheckout/v2/url`;

  return privateClient.post(url, checkoutObj);
}
function createCheckoutCoreSession(msisdn, sessionPayload) {
  const url = `/customers/${msisdn}/smartcheckout/v2/url`;

  return privateClient.post(url, sessionPayload, { params: { provider: "checkout-core" } });
}

function getBenefitStatus(msisdn, correlationId) {
  const url = `/customers/${msisdn}/recharges/result/${correlationId}`;

  return privateClient.get(url);
}

function getRecurrenceStatus(msisdn, correlationId) {
  const url = `/customers/${msisdn}/recharges/recurrence/result/${correlationId}`;

  return privateClient.get(url);
}

function getRecurrenceManagementUrl(msisdn) {
  const url = `/customers/${msisdn}/smartcheckout/recurrence/url`;
  return privateClient.post(url, { channel: getChannel(), msisdn });
}

export {
  getCheckoutUrlV2,
  createCheckoutCoreSession,
  getBenefitStatus,
  getRecurrenceStatus,
  getRecurrenceManagementUrl,
};
